import axios from 'axios';
// import CHECKOUT_API_URL on top ot the others
import { ECOMMERCE_API_URL, PORTAL_API_URL, CONTENT_API_URL, CHECKOUT_API_URL, COMMERCEMEDIA_API_URL } from './_constants';
import { queryGetCategory } from './_api';
import logger from 'helpers/logger';

export const getEquipmentByIdFromAdapter: (
	equipmentId: string,
	accessToken: any,
	locale: string,
	bpId: string,
) => Promise<Models.Equipment> = async (equipmentId, accessToken, locale, bpId) => {
	const method = 'GET';
	const headers = {};
	headers['Authorization'] = `Bearer ${accessToken}`;
	let path = `laboverview/GetLabEquipmentByBp=?locale=${locale}`
	
	if (bpId) {
		path += `&bpId=${bpId}`;
	}
	const ecommerceUrl = PORTAL_API_URL;
	const endpointUrl = `${ecommerceUrl}${path}`;
	// We need to replace with CHECKOUT below: 
	const contentApiUrl = CONTENT_API_URL;
	const commerceMediaApiUrl = COMMERCEMEDIA_API_URL;  // This one must be used for images to hit the image proxy
	
	return axios({
		url: endpointUrl,
		method: method,
		maxRedirects: 0,
		headers,
	})
		.then((res) => {
			const { data } = res;
			if (!data) {
				return null;
			}
			
			const equipment: Models.Equipment = {
				id: data.guid,
				serviceStatus: data.serviceStatus,
				serviceType: data.serviceType,
				serialnumber: data.serialnumber,
				picture: data.picture,
				serviceContract: data.serviceContract,
				name: data.displayName ? data.displayName : data.name,
				sku: data.sku,
				price: data.price, //'2253',
				image: data?.primaryImageUrl?.includes('http')
					? data.primaryImageUrl
					: commerceMediaApiUrl + (data.primaryImageUrl.charAt(0) == "/")? data.primaryImageUrl = data.primaryImageUrl.substr(1): data.primaryImageUrl,   // URL change to media proxy and remove leading slash if there.
				equipmentImages: data.equipmentImagesList.map((x) => {
					return x.includes('http') ? x : commerceMediaApiUrl + (x.charAt(0) == "/")? x = x.substr(1): x;  // Changed url to media proxy

				}),
				guid: data.guid,
				categories: data.categories,
			};
		
			return equipment;
		})
		.catch((error) => {			
			logger.error(`getEquipmentByIdFromAdapter ${error}`);
			throw new Error(error);
		});		
};

export const getEquipmentsByGuid = async (
	guid,
	facets,
	locale,
	accessToken,
	bpId,
	pageSize,
	page,
) => {
	const method = 'GET';
	const headers = {
		Accept: 'application/json, text/plain, */*',
		'Content-Type': 'application/json',
	};
	headers['Authorization'] = `Bearer ${accessToken}`;
	const path = 'api/laboverview/GetLabEquipmentByBp';

	const body = {
		guid: guid,
		page,
		pageSize,
		facets,
		locale,
		bpId,
	};

	const ecommerceUrl = PORTAL_API_URL
	const endpointUrl = `${ecommerceUrl}${path}`;
	const commerceMediaApiUrl = COMMERCEMEDIA_API_URL;  // This one must be used for images to hit the image proxy
	return axios({
		url: endpointUrl,
		method: method,
		maxRedirects: 0,
		headers,
		data: body,
	})
		.then((res) => {
			const { data } = res;
			const equipments = data?.businessPartners[0]?.labEquipment;
			
			if (equipments)
				for (let i = 0; i < equipments.length; i++) {
					const equipment = equipments[i];					
					if (equipment?.image && !equipment.image.includes('http')) {
						equipment.image = commerceMediaApiUrl +  equipment.image.replace(/^\/+/, '');											
					}
				}
			return {
				facets: facets,
				totalPageCount: data.totalPageCount,
				equipments: equipments.map((p) => ({
					...p,
				})),
			};
		})
		.catch((error) => {		
			logger.error(`getEquipmentsByGuid ${error}`);
			throw new Error(error);
		});
};

export const getGlobalCategoryByParent = async (
	parentId,
	accessToken,
	culture,
	bpId,
) => {
	const response = await queryGetCategory(
		parentId,
		accessToken,
		culture,
		bpId,
	);
	const category = response[0];

	const transformedCategory = {
		heading: category?.displayName ?? category?.name,
		categoryNumber: category?.count,
		id: category?.guid,
		categoryFilterItems: category?.subCategories?.map((subCat) => {
			return {
				children: subCat?.displayName ?? subCat?.name,
				categoryNumber: subCat?.count,
				id: subCat?.guid,
			};
		}),
		chosenSortingParameter: null,
	};

	return transformedCategory;
};

export const getAllCategories = async (accessToken, culture, bpId) => {
	const categories = await queryGetCategory(
		undefined,
		accessToken,
		culture,
		bpId,
	);

	const transformedCategories = {
		categoryListItems: categories.map((category) => {
			return {
				link: {
					children: category?.displayName ?? category.name,
					url: `/our-equipments/${category.name.toLowerCase()}`,
				},
				categoryNumber: category?.count,
				id: category?.guid,
			};
		}),
	};

	return transformedCategories;
};